<div *ngIf="renderData()"></div>
<div id="mapquest-geo-chart" class="geocode-chart-div"></div>
